import script from "./ClientTaskSpreadsheetRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientTaskSpreadsheetRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__